import Axios from "axios";
import config from "../app.config";

export var mailFolderService
export default mailFolderService = {
  getListMailFolder,
  createMailFolder,
  updateMailFolder,
  deleteMailFolder,
  moveToFolder,
}
async function getListMailFolder(data) {
  let mailBox = data.mailBox
  return await Axios.get(`${config.LOCAL_API_URL}/getListMailFolder/${mailBox}`)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}

async function createMailFolder(data) {
  let mailBox = data.mailBox
  return await Axios.post(`${config.LOCAL_API_URL}/createMailFolder/${mailBox}`, data)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}

async function updateMailFolder(data) {
  let mailBox = data.mailBox
  return await Axios.put(`${config.LOCAL_API_URL}/updateMailFolder/${mailBox}`, data)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}

async function deleteMailFolder(data) {
  let mailBox = data.mailBox
  let id = data.id
  return await Axios.delete(`${config.LOCAL_API_URL}/deleteMailFolder/${mailBox}`, {
    data: { id }
  })
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}

async function moveToFolder(data) {
  let mailBox = data.mailBox
  return await Axios.put(`${config.LOCAL_API_URL}/${mailBox}/moveToFolder`, data)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}